import * as React from 'react';
import { Column, SortDirection } from '../DataTable';

export interface ColumnHeaderProps {
    /**
     * The column this header is for
     */
    column: Column;
    /**
     * Function to handle this column being sorted
     */
    onSort?: (sortColumn: Column, sortDirection: SortDirection) => void;
    /**
     * The column currently being sorted on
     */
    sortColumn?: Column;
    /**
     * The direction we're currently sorting
     */
    sortDirection: SortDirection;
    /**
     * The function to handle the fill popup
     */
    onFill?: (fillAll: boolean, value?: string) => void;
    /**
     * The function to show the fill popup
     */
    showFillPopup: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export interface ColumnHeaderState {
    /**
     * The direction of the sort
     */
    sortDirection: SortDirection;
    /**
     * The column we're sorting on
     */
    sortColumn?: Column;
    /**
     * CSS Classes for the sort indicator span
     */
    sortClasses: string;
}

/**
 * This component represents a single column header
 */
export class ColumnHeader extends React.Component<
    ColumnHeaderProps,
    ColumnHeaderState
> {
    constructor(props: ColumnHeaderProps) {
        super(props);

        const sortClasses = this.getSortClasses(
            props.sortColumn,
            props.sortDirection
        );

        this.state = {
            sortColumn: props.sortColumn,
            sortDirection: props.sortDirection,
            sortClasses
        };
    }

    /**
     * Called automatically when this component's props are changed
     * @param nextProps The new props
     */
    componentWillReceiveProps(nextProps: ColumnHeaderProps) {
        const sortColumn = nextProps.sortColumn;
        const sortDirection = nextProps.sortDirection;
        const sortClasses = this.getSortClasses(sortColumn, sortDirection);

        this.setState({
            sortColumn,
            sortDirection,
            sortClasses
        });
    }

    render() {
        const column = this.props.column;
        return (
            <th
                onClick={() => this.handleClick()}
                className={'simple-data-table-header copia_color2_b'}
            >
                <span className="pull-left">
                    {column.title}{' '}
                    {column.type === 'INPUT' && (
                        <a
                            href="#"
                            className="fill-link"
                            onClick={event => {
                                event.preventDefault();
                                event.stopPropagation();
                                this.props.showFillPopup(event);
                                return false;
                            }}
                        >
                            (fill)
                        </a>
                    )}
                </span>
                <span className={this.state.sortClasses} />
            </th>
        );
    }

    private handleClick() {
        if (this.props.column.sortable && this.props.onSort) {
            this.props.onSort(this.props.column, this.getNewSortDirection());
        }
    }

    private getNewSortDirection(): SortDirection {
        if (this.state.sortColumn) {
            if (this.state.sortColumn === this.props.column) {
                if (this.state.sortDirection === 'ASCENDING') {
                    return 'DESCENDING';
                } else {
                    return 'ASCENDING';
                }
            } else {
                return 'ASCENDING';
            }
        } else {
            return 'ASCENDING';
        }
    }

    private getSortClasses(sortColumn: Column, sortDirection: SortDirection) {
        if (!this.props.column.sortable) {
            return '';
        }

        const classes = ['ui-icon', 'pull-right'];

        if (sortColumn === this.props.column) {
            if (sortDirection === 'ASCENDING') {
                classes.push('ui-icon-triangle-1-n');
            } else if (sortDirection === 'DESCENDING') {
                classes.push('ui-icon-triangle-1-s');
            }
        } else {
            classes.push('ui-icon-carat-2-n-s');
        }

        return classes.join(' ');
    }
}
